import * as CONSTANTS from '../../Constants/ActionTypes'
let initialState = {
  currentUser: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.payload,
      }
    default:
      return state
  }
}
